import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importEditEmailContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "EditEmailContainer" */
                '@perpay-web/fintech/components/containers/EditEmailContainer'
            ),
    );
